// Libs
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { Location, useLocation, useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
// Components, Layouts, Pages
// Others
import { VerifyTypeEnum } from '~/utils/enum/common';
import { ITypeSuccess } from '~/utils/interface/auth';
import { EMPTY_STRING, NAVIGATION_AUTH } from '~/utils/constants/common';
// Styles, images, icons
import styles from './Successfully.module.scss';
import { icons } from '~/assets';

type Props = {};

const cx = classNames.bind(styles);

const Successfully = (props: Props) => {
  //#region Destructuring Props

  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['common/auth', 'common/base']);
  const navigate = useNavigate();
  const { state }: Location<ITypeSuccess> = useLocation();
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const handleSuccessfullyTitle = () => {
    switch (state.type) {
      case VerifyTypeEnum.CREATE_ACCOUNT:
        return t('verify_successfully_title');
      case VerifyTypeEnum.FORGOT_PASSWORD:
        return t('forgot_password_successfully_title');
      default:
        return EMPTY_STRING;
    }
  };

  const handleSuccessfullyDescription = () => {
    switch (state.type) {
      case VerifyTypeEnum.CREATE_ACCOUNT:
        return t('verify_successfully_description');
      case VerifyTypeEnum.FORGOT_PASSWORD:
        return t('forgot_password_successfully_description');
      default:
        return EMPTY_STRING;
    }
  };

  const handleBackToLogin = () => {
    navigate(NAVIGATION_AUTH);
  };
  //#endregion Handle Function

  return (
    <Box component={'div'} id='successfullyPage' className={cx('container')}>
      <img
        src={icons.commonIconLogo}
        alt={t('common_alt_img', { ns: 'common/base' })}
        className={cx('logo')}
      />

      <Typography className={cx('title')}>{handleSuccessfullyTitle()}</Typography>

      <Typography className={cx('desc')}>{handleSuccessfullyDescription()}</Typography>

      <Button variant='contained' className={cx('buttonVerify')} onClick={() => handleBackToLogin()}>
        <Typography>{t('verify_successfully_button_back_login')}</Typography>
      </Button>
    </Box>
  );
};

export default Successfully;
